import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'cf-events',
    templateUrl: './events.component.html'
})
export class EventsComponent {
    public readonly pageTitle = this.window.ngData.section_title;
    public readonly tabData = {
        tabId: 'cf-events',
        tabList: [
            {
                active: undefined,
                externalUrl: false,
                title: 'events.Upcoming',
                url: 'upcoming'
            },
            {
                active: undefined,
                externalUrl: false,
                title: 'events.Past',
                url: 'past'
            }
        ]
    };

    constructor (
        private window: Window,
        private title: Title
    ) {
        this.title.setTitle(this.pageTitle);
    }
}
